import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_URL } from '../config/api';

const MaintenanceContext = createContext();

export const useMaintenance = () => {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error('useMaintenance must be used within a MaintenanceProvider');
  }
  return context;
};

export const MaintenanceProvider = ({ children }) => {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchMaintenance = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/settings/maintenance`);
      setMaintenanceMode(!!response.data.maintenanceMode);
    } catch (error) {
      console.error('Error fetching maintenance status:', error);
      setMaintenanceMode(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMaintenance();
  }, [fetchMaintenance]);

  const value = {
    maintenanceMode,
    setMaintenanceMode,
    loading,
    refetch: fetchMaintenance
  };

  return (
    <MaintenanceContext.Provider value={value}>
      {children}
    </MaintenanceContext.Provider>
  );
};
